
import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

// Correctly define GetDists
const GetDists = ({ onLoadingChange, onChange }) => {
  const [options, setOptions] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
         const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/Common/getDistrictsAllIncSelect`);
        //const response = await fetch('http://localhost:8080/Common/getDistrictsAll');
        const data = await response.text();
        setOptions(data);
      } catch (error) {
        console.error("Error fetching Districts:", error);
      } finally {
        setLoading(false);
        onLoadingChange(false);
      }
    };
    fetchDistricts();
  }, [onLoadingChange]);

  const handleChange = (event) => {
    onChange(event.target.value); // Pass selected district code to parent
  };

  return (
    <div>
      {loading ? (
        <Skeleton width={50} height={40} />
      ) : (
        <select name="dist_code" id="dist_code" dangerouslySetInnerHTML={{ __html: options }} onChange={handleChange} />
      )}
    </div>
  );
};

// Export the main GetDistricts component
const GetAllDistrictsAll = ({ onLoadingChange, onChange }) => {
  return (
    <>
      <GetDists onLoadingChange={onLoadingChange} onChange={onChange} />
    </>
  );
};

export default GetAllDistrictsAll;